import { BaseCommand } from "@crunchdao/shared-cli";
import { StakingClient, formatCrunch, parseCrunch } from "@crunchdao/sdk";

export class WithdrawCommand extends BaseCommand {
  async execute(amount: number): Promise<void> {
    try {
      this.displayAction(`Withdrawing ${formatCrunch(parseCrunch(amount))} CRNCH`);

      const stakingClient = new StakingClient({
        connection: this.provider.connection,
        wallet: this.provider.wallet,
      });

      const signature = await stakingClient.withdrawAmount(amount);

      this.displayActionComplete(`Withdrew ${formatCrunch(parseCrunch(amount))} CRNCH`);
      console.log(`Transaction: ${signature}`);
    } catch (error) {
      console.error("❌ Error withdrawing tokens:", error);
      throw error;
    }
  }
}
